import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const StyledListingBox = styled(Box)<{
  top: string;
  bottom?: string;
  borderWidth: number;
}>`
  background: white;
  display: flex;
  flex-direction: column;
  padding: 0.75rem 0;
  overflow-y: auto;
  position: fixed;
  top: ${({ top }) => top};
  left: 0;
  right: 0;
  bottom: ${({ bottom }) => bottom || 0};
  border-color: mercury;
  border-top-width: ${({ borderWidth }) => `${borderWidth}px`};
`
